<div class="table-container">
  <!-- Table -->
  <div 
    class="table-wrapper"
    [class.table-scrollable]="scrollable"
    [style.max-height]="scrollable ? scrollHeight : 'none'"
  >
    <!-- Decorative Leaf Images Background -->
    <div class="table-leaf-background">
      <img src="/leaf/Group 6.svg" alt="Decorative leaf" class="table-leaf table-leaf-1" />
      <img src="/leaf/Group 8.svg" alt="Decorative leaf" class="table-leaf table-leaf-2" />
      <img src="/leaf/Group 9.svg" alt="Decorative leaf" class="table-leaf table-leaf-3" />
      <img src="/leaf/Group 11.svg" alt="Decorative leaf" class="table-leaf table-leaf-4" />
    </div>
    
    <table 
      class="table"
      [class.table-striped]="striped"
      [class.table-bordered]="bordered"
      [class.table-hoverable]="hoverable"
      [class.table-has-fixed-right]="hasFixedRightColumn"
      [class.table-has-fixed-left]="hasFixedLeftColumn"
    >
      <!-- Header -->
      <thead class="table--header" [style.background-color]="'#11634f'">
        <tr class="table--row">
          <th 
            *ngFor="let column of columns" 
            class="table--cell table--header-cell"
            [class.expand-column]="column.key === 'expand' || column.key === '_expand'"
            [class.fixed-left]="column.fixed === 'left'"
            [class.fixed-right]="column.fixed === 'right'"
            [style.width]="column.width"
            [style.text-align]="column.align || 'left'"
            [class.sortable]="column.sortable"
            (click)="column.sortable && onSort(column)"
          >
            <span *ngIf="!column.headerTemplate" class="table--header-content">
              {{ column.label }}
              <span 
                *ngIf="column.sortable" 
                class="table--sort-icon"
                [class.active-sort]="sortColumn === column.key"
              >
                {{ getSortIcon(column) }}
              </span>
            </span>
            <ng-container *ngIf="column.headerTemplate">
              <ng-container *ngTemplateOutlet="column.headerTemplate; context: { $implicit: column }"></ng-container>
            </ng-container>
          </th>
        </tr>
      </thead>

      <!-- Body -->
      <tbody class="table--body">
        <!-- Loading Skeleton -->
        <ng-container *ngIf="loading">
          <tr *ngFor="let row of getSkeletonRows(); let i = index" class="table--row table--skeleton-row">
            <td *ngFor="let column of columns" class="table--cell table--skeleton-cell" [class.expand-column]="column.key === 'expand' || column.key === '_expand'" [class.fixed-left]="column.fixed === 'left'" [class.fixed-right]="column.fixed === 'right'" [style.text-align]="column.align || 'left'" [style.width]="column.width">
              <div class="skeleton skeleton-text"></div>
            </td>
          </tr>
        </ng-container>

        <!-- Empty State -->
        <tr *ngIf="!loading && (!data || data.length === 0)" class="table--row table--empty-row">
          <td [attr.colspan]="columns.length" class="table--cell table--empty-cell">
            <div class="table--empty-message" [innerHTML]="safeEmptyMessage"></div>
          </td>
        </tr>

        <!-- Data Rows -->
        <ng-container *ngIf="!loading && data && data.length > 0">
          <ng-container *ngFor="let row of displayedData; let i = index">
            <tr class="table--row table--data-row" [class.table--dropdown-row-open]="dropdownOpenRowIndex === i">
              <td 
                *ngFor="let column of columns" 
                class="table--cell table--data-cell"
                [class.expand-column]="column.key === 'expand' || column.key === '_expand'"
                [class.fixed-left]="column.fixed === 'left'"
                [class.fixed-right]="column.fixed === 'right'"
                [style.text-align]="column.align || 'left'"
                [style.width]="column.width"
              >
                <span *ngIf="!column.cellTemplate" class="table--cell-content" [attr.title]="getCellValue(row, column)">
                  <span *ngIf="shouldShowIcon(column) && getAssetIcon(getCellValue(row, column))" class="table--cell-with-icon">
                    <img [src]="getAssetIcon(getCellValue(row, column))" [alt]="getCellValue(row, column)" class="table--asset-icon" />
                    <span>{{ getCellValue(row, column) }}</span>
                  </span>
                  <span *ngIf="(!shouldShowIcon(column) || !getAssetIcon(getCellValue(row, column))) && !isDateColumn(column)">
                    {{ getCellValue(row, column) }}
                  </span>
                  <span *ngIf="(!shouldShowIcon(column) || !getAssetIcon(getCellValue(row, column))) && isDateColumn(column)" class="table--date-cell">
                    <span class="table--date-part">{{ getDatePart(getCellValue(row, column)) }}</span>
                    <span class="table--time-part">{{ getTimePart(getCellValue(row, column)) }}</span>
                  </span>
                </span>
                <ng-container *ngIf="column.cellTemplate">
                  <ng-container *ngTemplateOutlet="column.cellTemplate; context: { $implicit: row, column: column, rowIndex: i }"></ng-container>
                </ng-container>
              </td>
            </tr>
            <!-- Child Row -->
            <ng-container *ngIf="childRowTemplate && isRowExpanded && isRowExpanded(row)">
              <ng-container *ngTemplateOutlet="childRowTemplate; context: { $implicit: row }"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <p-paginator
    *ngIf="shouldShowPagination && !loading"
    [rows]="pagination.pageSize"
    [totalRecords]="pagination.totalItems"
    [first]="(pagination.currentPage - 1) * pagination.pageSize"
    [rowsPerPageOptions]="[]"
    (onPageChange)="onPageChange($event)"
    styleClass="table--paginator"
  ></p-paginator>
</div>



